<template>
  <van-form ref="form" @submit="submitForm">
    <div class="form-item">
      <!-- <van-field label="客户" readonly right-icon="arrow" placeholder="请选择客户" :value="formData.customerName"
        @click="visible = 'customerPopup'" /> -->

      <!-- 创建新客户 -->
      <div style="display: flex;">
        <van-field v-model="formData.customerTel" label="客户手机号" type="number" placeholder="请先输入客户手机号"
          @input="searchCustomerTel" style="width: 85%;" />
        <van-button size="mini" @click="$router.push({ name: 'CreateCustomer' })"
          style="color:#F59A23;margin-top: 10px;">创建客户</van-button>
      </div>
      <van-field v-model="formData.customerName" label="客户姓名" placeholder="根据手机号自动回填，不存在会创建客户"
        :readonly="readonlyCustomerName" />

      <!-- <van-field v-if="!headmaster" :value="getStaffName(formData.orderOwnerId)" label="客户归属人" readonly
        :disabled="headmaster" placeholder="请填写客户归属人" :rules="[
          {
            required: headmaster ? false : true,
            message: '请填写客户归属人',
            trigger: 'onChange',
          },
        ]" right-icon="arrow" @click="
          (showStaffPick = headmaster || hasParentName ? false : true),
          (staffKey = 'orderOwnerId')
          " /> -->
      <van-field v-if="!headmaster" :value="getStaffName(formData.customerParentId)" label="客户归属人" readonly
        :disabled="headmaster" placeholder="请填写客户归属人" :rules="[
          {
            required: headmaster ? false : true,
            message: '请填写客户归属人',
            trigger: 'onChange',
          },
        ]" right-icon="arrow" @click="showPopupSelectStaff('customerParentId')" />
      <!-- 订单类型 -->
      <template>
        <van-field :value="formData.orderType | orderType" label="订单类型" clickable readonly placeholder="请选择订单类型" :rules="[
          { required: true, message: '请选择订单类型', trigger: 'onChange' },
        ]" right-icon="arrow" @click="showOrderPick = true" />
        <van-popup v-model="showOrderPick" round position="bottom">
          <van-picker title="订单类型" show-toolbar value-key="name" :columns="orderList" @cancel="showOrderPick = false"
            @confirm="orderTypeConfirm" />
        </van-popup>

        <van-field v-if="formData.orderType === 1 || formData.orderType === 5" :value="formData.summitName" label="峰会名称"
          clickable readonly placeholder="请选择峰会名称" right-icon="arrow" @click="showsummit = true" />
        <van-popup v-model="showsummit" round position="bottom">
          <!-- 快捷搜索 -->
          <van-search show-action autofocus clearable placeholder="搜索峰会名称" v-model="searchSummitName"
            @input="handelsearchSummitName">
            <template #action>
              <van-button @click="handelsearchSummitName" size="small">搜索</van-button>
            </template>
          </van-search>
          <van-picker title="峰会名称" show-toolbar value-key="name" :columns="lessonList" @cancel="showsummit = false"
            @confirm="summitChange" />

        </van-popup>

        <!-- <el-form-item v-if="form.orderType === 1 || form.orderType === 5" label="峰会名称">
          <el-select v-model.number="form.summitId" placeholder="请选择峰会名称" @change="summitChange">
            <el-option v-for="item in lessonList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item> -->
        <!-- 师训课 -->
        <template v-if="[2, 3, 4].includes(formData.orderType)">
          <van-field label="选择项目" :value="getProjectName(formData.projectId)" placeholder="请选择项目" clickable readonly
            :rules="[
              {
                required: true,
                message:
                  formData.orderType === 3 ? '请选择师训课' : '请选择项目',
                trigger: 'onChange',
              },
            ]" @click="showProject = true" />
        </template>
        <!-- 峰会 -->
        <template v-if="formData.orderType === 5 || formData.orderType === 3">
          <van-field :value="summitCourseName" label="时间" readonly placeholder="请选择时间" :rules="[
            { required: true, message: '请选择时间', trigger: 'onChange' },
          ]" @click="shoTimePicker = true" />
        </template>
        <van-field label="机构" readonly clickable placeholder="请选择机构" :disabled="!formData.customerName"
          :value="region.regionName" @click="visible = formData.customerName ? 'region' : ''" />
      </template>
    </div>
    <div class="form-item">
      <h4>
        <span>支付信息</span>
        <template v-if="formData.orderType === 3 &&
          [undefined, true].indexOf(hasParentName) === -1
        ">
          <van-checkbox v-model="headmaster" icon-size="14px" shape="square">校长报名</van-checkbox>
        </template>
      </h4>
      <van-field :value="price" readonly label="商品金额" type="digit" placeholder="根据订单信息和客户信息自动计算" />
      <van-field :value="formData.created" label="下单日期" placeholder="请选择客户下单时间" right-icon="arrow" readonly
        @click="visible = 'datePicker'" />
      <!-- <van-field :value="getStaffName(formData.orderSubmitOwnerId)" readonly label="订单成交人" placeholder="请填写订单成交人"
        :rules="[
          { required: true, message: '请选择订单成交人', trigger: 'onChange' },
        ]" @click="(showStaffPick = true), (staffKey = 'orderSubmitOwnerId')" /> -->
      <van-field :value="getStaffName(formData.orderSubmitOwnerId)" readonly label="订单成交人" placeholder="请填写订单成交人"
        :rules="[
          { required: true, message: '请选择订单成交人', trigger: 'onChange' },
        ]" @click="showPopupSelectStaff('orderSubmitOwnerId')" />
      <!-- <van-field :value="getStaffName(formData.customerParentId)" readonly label="订单归属人" placeholder="请选择订单归属人" :rules="[
        { required: true, message: '请选择订单归属人', trigger: 'onChange' },
      ]" @click="
        (showStaffPick = hasParentName ? false : true),
        (staffKey = 'customerParentId')
        " /> -->
      <van-field :value="getStaffName(formData.orderOwnerId)" readonly label="订单归属人" placeholder="请选择订单归属人" :rules="[
        { required: true, message: '请选择订单归属人', trigger: 'onChange' },
      ]" @click="showPopupSelectStaff('orderOwnerId')" />
      <van-field :value="shouldPay" :readonly="price === ''" label="订单金额" type="number" placeholder="请输入订单金额"
        @input="shouldPay = $event.match(/^\d*(\.?\d{0,2})/g)[0]" />
      <van-field v-model="formData.updateShouldPayInfo" v-if="price && Number(shouldPay) !== price" type="textarea"
        label="修改金额说明" rows="1" :rules="[
          {
            required: true,
            message: '订单金额与商品金额不一致，需填写修改金额原因',
            trigger: 'onBlur',
          },
        ]" :maxlength="100" autosize placeholder="请输入修改订单金额的原因" />
      <template v-if="formData.orderType === 3 && headmaster">
        <van-field label="项目客户" :value="headmasterName" readonly placeholder="请选择已购买该项目的客户" @click="handleSelect" />
      </template>
      <van-field :value="formData.payType | payType" label="支付方式" clickable readonly placeholder="请选支付方式" :rules="[
        { required: true, message: '请选择支付方式', trigger: 'onChange' },
      ]" @click="showPayment = true" />
      <van-popup v-model="showPayment" round position="bottom">
        <van-picker title="支付方式" show-toolbar :value="formData.payType" value-key="name" :columns="paymentList"
          @cancel="showPayment = false" @confirm="paymentConfirm" />
      </van-popup>
      <van-field label="支付凭证" v-model="formData.tradeNo" placeholder="请输入支付凭证" :rules="[
        { required: true, message: '请输入支付凭证', trigger: 'onChange' },
      ]" />
      <van-field placeholder="请上传支付凭证" :rules="[
        { required: true, message: '请上传支付凭证', trigger: 'onChange' },
      ]">
        <template #input>
          <UploadImage @uploadImage="formData.image = $event" />
        </template>
      </van-field>
    </div>
    <div class="form-footer">
      <van-button type="primary" :loading="loading" size="small" native-type="submit"
        loading-text="正在下单...">确定</van-button>
    </div>
    <!-- 峰会时间 ｜ 师训课时间 -->
    <van-popup v-model="shoTimePicker" round position="bottom">
      <van-picker show-toolbar title="时间" value-key="data" :columns="dateColumns" @cancel="shoTimePicker = false"
        @confirm="handleSummitCourseId" />
    </van-popup>
    <!-- 项目列表 ｜ 师训课项目 -->
    <van-popup v-model="showProject" round position="bottom">
      <van-search show-action autofocus clearable placeholder="搜索项目名称" v-model="queryProjectName"
        @input="onSearchProject">
        <template #action>
          <van-button @click="onSearchProject" size="small">搜索</van-button>
        </template>
      </van-search>
      <van-picker show-toolbar title="项目" value-key="projectName" :columns="projectList" @cancel="showProject = false"
        @confirm="handleProject" />
    </van-popup>
    <!-- 校长列表 -->
    <van-popup v-model="showHeadmaster" round position="bottom">
      <van-picker show-toolbar title="已购客户列表" value-key="customerName" :columns="headmasterList"
        @cancel="showHeadmaster = false" @confirm="handleHeadmasterId" />
    </van-popup>
    <StaffModal :visible.sync="showStaffPick" :staffList="staffList" @modifyUserId="modifyUserId" />
    <!-- 客户列表 -->
    <CustomerPopup :visible="visible === 'customerPopup'" @select-item="handleSelectCustomer"
      @update:visible="visible = ''" />
    <!-- 日期选择器 -->
    <DatePicker :visible="visible === 'datePicker'" :currentDate="formData.created"
      @changeDate="formData.created = $event" @update:visible="visible = ''" />
    <!-- 机构列表 -->
    <van-popup :value="visible === 'region'" round :close-on-click-overlay="false" position="bottom">
      <div class="region">
        <div class="region-title border-bottom">购买项目的机构</div>
        <div class="region-content">
          <ul class="region-list">
            <li v-for="item in region.regionList" :key="item.id" @click="handleSelectRegion(item)">
              {{ item.orgName }}
            </li>
          </ul>
        </div>
        <div class="region-footer">
          <div class="add-region border-bottom" @click="region.showAddRegion = true">
            添加机构
          </div>
          <van-button size="small" @click="visible = ''">取 消</van-button>
        </div>
      </div>
    </van-popup>
    <!-- 添加机构 -->
    <AddRegion v-if="region.showAddRegion" :visible.sync="region.showAddRegion" @saveRegion="handleAddRegion" />

    <!--选择员工 -->
    <van-popup v-model="showSelectStaff" position="bottom" :style="{ height: '70%' }" closeable close-icon="close"
      round>
      <!-- 联动搜索 -->

      <div style="margin-top: 30px;">
        <van-search v-model="filterText" placeholder="请输入搜索关键词" shape="round" @input="searchFilterText" />
        <van-tree-select :items="items" :active-id.sync="activeId" :main-active-index.sync="activeIndex" height="700px"
          @click-item="handleNodeClick" />
      </div>

    </van-popup>
  </van-form>
</template>

<script>
import { mapGetters } from "vuex";
import { Decimal } from "decimal.js";
import DatePicker from "@/components/date/datePicker";
import UploadImage from "@/components/img/upload";
import StaffModal from "./staffModal";
import AddRegion from "@/components/region";
import CustomerPopup from "@/views/customerManage/customer/components/list";
import {
  summitCourseList,
  projectTeacherCourseList,
  projectSetList,
  customerList,
  createOrder,
  summitList,
  adminAllList,
} from "@/api/order";
import { getCustomerRegionList, createCustomerRegion, createCustomer } from "@/api/customer";
import { telRegExp } from "@/utils";
import dayjs from "dayjs";
export default {
  name: "CreateOrder",
  components: { UploadImage, StaffModal, CustomerPopup, DatePicker, AddRegion },
  data() {
    return {
      searchSummitName: "",
      readonlyCustomerName: true,
      selectFiled: "",
      filterText: "",
      activeId: 1,
      activeIndex: 0,
      items: [],
      showSelectStaff: false,
      region: {
        showAddRegion: false,
        regionName: "",
        regionList: [],
      },
      customerId: "", // 客户id
      visible: "",
      shouldPay: undefined, // 订单修改金额
      loading: false,
      isPurchased: false, // 该用户是否已经购买
      headmaster: false, // 校长报名
      headmasterName: "", // 校长名称
      telPattern: telRegExp, // 电话正则
      showStaffPick: false,
      showOrderPick: false,
      showsummit: false,
      shoTimePicker: false,
      showPayment: false,
      showProject: false, // 显示项目列表
      summitCourseName: "", // 峰会名称
      hasParentName: undefined, // 客户归属人
      staffKey: "",
      formData: {
        customerParentId: undefined, // 客户归属人
        customerOrgId: undefined,
        summitCourseId: undefined, // 峰会课程id
        customerIdCard: undefined, // 客户身份证
        orderSubmitOwnerId: undefined, // 订单成交人
        orderType: 1, // 订单类型， 1、峰会 2、项目 3、师训课
        headmasterId: undefined, // 校长id
        customerTel: undefined, // 顾客电话
        customerName: undefined, // 顾客姓名
        payType: undefined, // 支付方式
        tradeNo: undefined, // 支付凭证(付款编码)
        projectId: undefined, // 项目id
        projectTeacherCourseId: undefined, // 师训课id
        image: undefined, // 支付图片凭证
        updateShouldPayInfo: undefined, // 应付金额修改说明
        created: dayjs().format("YYYY-MM-DD"),
        summitId: '',
        summitType: '',
      },
      orderList: [
        { name: "峰会", value: 1 },
        { name: "项目", value: 2 },
        { name: "师训课", value: 3 },
        { name: "普通商品", value: 4 },
        { name: "峰会师训课", value: 5 }
      ],
      paymentList: [
        { name: "微信支付", value: 1 },
        { name: "支付宝", value: 2 },
        { name: "现金", value: 3 },
        { name: "pos机代刷", value: 4 },
      ],
      dateColumns: [],
      projectList: [],
      showHeadmaster: false,
      headmasterList: [], // 校长列表
      lessonList: [],
      queryProjectName: "",
      customerSearchExsit: false,
    };
  },
  watch: {
    price(newVal) {
      this.shouldPay = newVal;
    }
  },
  computed: {
    ...mapGetters(["userInfo", "staffList"]),
    price() {
      const { orderType, summitCourseId, projectId, projectTeacherCourseId, summitId } =
        this.formData;
      let money = 0;
      switch (orderType) {
        case 1:
          console.log(6666, summitId, this.lessonList)
          if (summitId && this.lessonList.length) {
            const res = this.lessonList.find(
              (item) => item.id === summitId
            );
            if (res) {
              // 有归属人，订单金额是优惠价，反之原价
              // money = this.hasParentName ? res.discountPrice : res.price;
              money = res.price;
              if (res && res.price == 0) {
                money = -1
              }
            }
          }
          break;
        case 5:
          if (summitCourseId) {
            const res = this.dateColumns.find(
              (item) => item.id === summitCourseId
            );
            if (res) {
              // 有归属人，订单金额是优惠价，反之原价
              // money = this.hasParentName ? res.discountPrice : res.price;
              money = res.price;
              if (res && res.price == 0) {
                money = -1
              }
            }
          }
          break;
        case 2:
        case 4:
          if (projectId) {
            const res = this.projectList.find((item) => item.id === projectId);
            money = res ? res.price : "";
            if (res && res.price == 0) {
              money = -1
            }
          }
          break;
        case 3:
          if (projectTeacherCourseId) {
            const res = this.dateColumns.find(
              (item) => item.id === projectTeacherCourseId
            );
            money = res
              ? this.isPurchased || this.formData.headmasterId
                ? res.discountPrice
                : res.price
              : "";

            if (res && res.price == 0) {
              money = -1
            }
          }
          break;
        default:
          break;
      }
      if (money == -1) {
        return 0
      }
      return money
        ? new Decimal(money)
          .div(new Decimal(100))
          .toDecimalPlaces(2, Decimal.ROUND_UP)
          .toNumber()
        : "";
    },
  },
  created() {
    this.orderTypeConfirm(this.orderList[0]);
    if (!this.staffList || !this.staffList.length) {
      this.$store.dispatch("user/getStaffList", { page: 1, count: 1000 });
    }
    this.formData.orderSubmitOwnerId = this.userInfo.id || "";
    summitList({ page: 1, count: 1000 }).then(res => {
      if (res.errcode === 0 && res.data.length) {
        this.lessonList = res.data
      }
    })
    this.getAdminAllList()
  },
  activated() {
    if (this.$refs.form) {
      this.$refs.form.resetValidation();
    }
  },
  methods: {
    getAdminAllList(keyword) {
      let query = { page: 1, count: 2000 }
      if (keyword) {
        query.name = keyword
      }
      adminAllList(query).then(res => {
        if (res.errcode === 0 && res.data.length) {
          let childrenSale = []
          let childrenCustormServe = []
          let childrenHehuoren = []
          let childrenJiangshi = []
          for (let item of res.data) {
            if (item['Staff.type'] == 0 && item.status == 1) {
              childrenSale.push({
                id: item.id,
                text: item.name
              })
            }
            if (item['Staff.type'] == 1 && item.status == 1) {
              childrenCustormServe.push({
                id: item.id,
                text: item.name
              })
            }
            if (item['Staff.type'] == 2 && item.status == 1) {
              childrenHehuoren.push({
                id: item.id,
                text: item.name
              })
            }
            if (item['Staff.type'] == 3 && item.status == 1) {
              childrenJiangshi.push({
                id: item.id,
                text: item.name
              })
            }
          }

          this.items.push({
            id: 1,
            text: '销售',
            children: childrenSale
          })

          this.items.push({
            id: 2,
            text: '客服',
            children: childrenCustormServe
          })

          this.items.push({
            id: 3,
            text: '合伙人',
            children: childrenHehuoren
          })
          this.items.push({
            id: 4,
            text: '讲师',
            children: childrenJiangshi
          })
        }
      })
    },
    handelsearchSummitName() {
      let query = {
        page: 1, count: 1000
      }
      if (this.searchSummitName.length != 0) {
        query.name = this.searchSummitName
      }
      summitList(query).then(res => {
        if (res.errcode === 0 && res.data.length) {
          this.lessonList = res.data
        }
      })
    },
    searchCustomerTel() {
      // 校验手机号
      if (this.formData.customerTel.length == 11) {
        //11位数的数字类型即可
        if (!/^-?\d+(\.\d+)?$/.test(this.formData.customerTel)) {
          return this.$toast("手机号格式不正确");
        }
        customerList({
          customerTel: this.formData.customerTel,
          count: 1000,
          page: 1,
        }).then((res) => {
          if (res.errcode === 0 && res.data.length) {
            this.formData.customerName = res.data[0].customerName
            this.customerSearchExsit = true
            if (res.data[0].parentId) {
              this.formData.customerParentId = res.data[0].parentId
              this.formData.orderOwnerId = res.data[0].parentId
            }
            this.readonlyCustomerName = true
          } else {
            this.formData.customerName = ""
            this.readonlyCustomerName = false
            delete this.formData.customerParentId
            this.customerSearchExsit = false
          }
        }
        )
      }

      if (this.formData.customerTel.length > 11) {
        if (!/^-?\d+(\.\d+)?$/.test(this.formData.customerTel)) {
          return this.$toast("手机号格式不正确");
        }
      }

    },
    searchFilterText() {
      this.items = []
      // 员工关键字搜索
      this.getAdminAllList(this.filterText)
      let tree = this.items
      let keyword = this.filterText
      for (let ele of tree) {
        for (let ele2 of ele.children) {
          if (ele2.text == keyword) {
            this.activeId = ele2.id
            this.activeIndex = ele.id - 1
            return
          }
        }
      }

    },
    handleNodeClick(data) {
      if (data.text == "销售" || data.text == "客服" || data.text == "合伙人" || data.text == "讲师") {
        return
      }
      if (this.selectFiled == "customerParentId") {
        this.formData.customerParentId = data.id
        this.formData.customerParentName = data.text
      }
      if (this.selectFiled == "orderSubmitOwnerId") {
        this.formData.orderSubmitOwnerId = data.id
      }
      if (this.selectFiled == "orderOwnerId") {
        this.formData.orderOwnerId = data.id
      }
      this.activeId = 1
      this.activeIndex = 0
      this.showSelectStaff = false
    },
    showPopupSelectStaff(field) {
      if (field == "customerParentId") {
        if (this.formData.customerParentId && this.formData.customerParentId != 0) {
          return
        }
      }
      this.selectFiled = field
      this.showSelectStaff = true
    },
    onSearchProject() {
      let value = 2
      if (this.formData.orderType == 4) {
        value = 4
      }
      this.orderTypeConfirm({
        name: "项目",
        value: value,
        projectName: this.queryProjectName
      })
    },
    // 提交订单
    submitForm() {
      this.loading = true;
      const params = {
        ...this.formData,
        summitCourseId: (this.formData.orderType === 5 && this.formData.summitId) ? this.formData.summitCourseId : undefined,
        summitId: (this.formData.orderType === 1 || this.formData.orderType === 5) ? this.formData.summitId : undefined,
        shouldPay:
          Number(this.shouldPay) === this.price
            ? undefined
            : new Decimal(this.shouldPay)
              .mul(new Decimal(100))
              .toDecimalPlaces(0, Decimal.ROUND_UP)
              .toNumber(),
      };
      params.orderDate = parseInt(Number(new Date(params.created)) / 1000)
      params.created = undefined

      //客户姓名输入法，非禁用可输入状态是新客户
      if (this.readonlyCustomerName == false) {
        if (this.customerSearchExsit) {
          createOrder(params).then((res) => {
            this.loading = false;
            if (res.errcode === 0) {
              this.$store
                .dispatch("tagsView/delCachedView", this.$route)
                .then(() => {
                  // 表单成提交功后删除当前缓存路由
                  this.$router.push({ name: "OrderList" });
                });
            }
          });
        } else {
          createCustomer({
            customerName: this.formData.customerName,
            customerTel: this.formData.customerTel,
            isAddByOrder: 1
          }).then((res) => {
            if (res.errcode === 0) {
              createOrder(params).then((res) => {
                this.loading = false;
                if (res.errcode === 0) {
                  this.$store
                    .dispatch("tagsView/delCachedView", this.$route)
                    .then(() => {
                      // 表单成提交功后删除当前缓存路由
                      this.$router.push({ name: "OrderList" });
                    });
                }
              });
            }
          })
        }

      } else {
        createOrder(params).then((res) => {
          this.loading = false;
          if (res.errcode === 0) {
            this.$store
              .dispatch("tagsView/delCachedView", this.$route)
              .then(() => {
                // 表单成提交功后删除当前缓存路由
                this.$router.push({ name: "OrderList" });
              });
          }
        });
      }

    },
    summitChange(val) {
      this.formData.summitName = val.name
      this.formData.summitId = val.id
      this.showsummit = false
      if (this.formData.orderType === 5) {
        summitCourseList({ page: 1, count: 1000, summitId: val.id }).then((res) => {
          if (res.errcode === 0) {
            const temp = [];
            res.data.forEach((item) => {
              if (item.status === 1) {
                temp.push({ name: item.data, value: item.id, ...item });
              }
            });
            console.log(123, temp)
            this.dateColumns = temp;
          }
        });
      }
      console.log(val)
    },
    // 选择订单类型
    orderTypeConfirm(val) {
      console.log(val, "====orderTypeConfirm")
      this.formData.orderType = val.value;
      this.orderName = val.name;
      this.showOrderPick = false;
      switch (
      val.value // 根据不同的订单类型，请求对应数据
      ) {
        case 1: // 峰会
          this.summitCourseName = "";
          // summitCourseList({ page: 1, count: 1000 }).then((res) => {
          //   if (res.errcode === 0) {
          //     const temp = [];
          //     res.data.forEach((item) => {
          //       if (item.status === 1) {
          //         temp.push({ name: item.data, value: item.id, ...item });
          //       }
          //     });
          //     console.log(123, temp)
          //     this.dateColumns = temp;
          //   }
          // });
          break;
        case 2: // 项目
        case 4:
          this.formData.projectId = undefined;
          let projectSetListparams = { page: 1, count: 1000, type: val.value }
          if (val.projectName) {
            projectSetListparams.projectName = val.projectName
          }
          projectSetList(projectSetListparams).then(
            (res) => {
              if (res.errcode === 0) {
                this.projectList = res.data.filter((item) => item.status === 1);
              }
            }
          );
          break;
        case 3: // 师训课
          this.summitCourseName = "";
          this.formData.projectId = undefined;
          this.dateColumns = [];
          projectSetList({ page: 1, count: 1000, type: val.value }).then(
            (res) => {
              if (res.errcode === 0) {
                this.projectList = res.data.filter((item) => item.status === 1);
              }
            }
          );
          break;
        default:
          console.log("订单类型不存在");
          break;
      }
    },
    paymentConfirm(val) {
      this.showPayment = false;
      this.formData.payType = val.value;
    },
    /**
     * 峰会id
     * @param { name: 峰会时间, value: 峰会id }
     */
    handleSummitCourseId(item) {
      this.shoTimePicker = false;
      this.formData.projectTeacherCourseId = undefined;
      if (item) {
        switch (this.formData.orderType) {
          case 1:
            this.formData.summitCourseId = item.value;
            break;
          case 2:
            break;
          case 3:
            this.formData.projectTeacherCourseId = item.id;
            this.queryCustomInfo();
            break;
        }
        this.summitCourseName = item.data || item.name;
        console.log(12346588, this.summitCourseName, item)
      }
    },
    // 查询顾客列表
    queryCustomList(customerTel, projectTeacherCourseId) {
      return new Promise((resolve, reject) => {
        customerList({
          customerTel,
          count: 1000,
          page: 1,
          projectTeacherCourseId,
        }).then((res) => {
          if (res.errcode === 0 && res.data.length) {
            // 查询到顾客信息
            resolve(res);
          } else {
            reject(res);
          }
        });
      });
    },
    handleProject(val) {
      if (this.formData.orderType === 3) {
        // 师训课
        this.formData.projectId = val.id;
        this.summitCourseName = val.data;
        this.dateColumns = [{ ...val, name: val.data, value: val.id }];
        projectTeacherCourseList({
          page: 1,
          count: 1000,
          projectId: val.id,
        }).then((res) => {
          if (res.errcode === 0) {
            this.dateColumns = res.data;
          }
        });
      } else {
        this.formData.projectId = val.id;
        this.summitCourseName = val.projectName;
      }
      this.showProject = false;
    },
    /**
     * 获取员工名称
     * @param { val: 员工id }
     */
    getStaffName(val) {
      if (val) {
        const res = this.staffList.find((item) => item.id === val);
        return res ? res.name : '' // 取不到name不要把id显示出来。 val;
      }
    },
    getProjectName(val) {
      if (val) {
        const res = this.projectList.find((item) => item.id === val);
        return res ? res.projectName : val;
      }
    },
    modifyUserId(user) {
      // 修改用户id
      this.formData[this.staffKey] = user.id;
    },
    handleSelect() {
      // 查询已购买师训课项目客户
      const { projectTeacherCourseId } = this.formData;
      this.queryCustomList(undefined, projectTeacherCourseId)
        .then((res) => {
          this.showHeadmaster = true;
          this.headmasterList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleHeadmasterId(val) {
      this.showHeadmaster = false;
      this.headmasterName = val.customerName; // 校长名称
      this.formData.headmasterId = val.id; // 校长id
    },
    /**
     * 选择客户
     */
    handleSelectCustomer(item) {
      const { customerName, customerTel, customerIdCard, id, parentId } = item;
      Object.assign(this.formData, {
        customerTel: customerTel || undefined,
        customerIdCard: customerIdCard || undefined,
        customerName: customerName || undefined,
        customerOrgId: undefined,
        orderOwnerId: parentId || undefined,
        customerParentId: parentId || undefined,
      });
      this.hasParentName = !!parentId; // 是否有归属人
      this.region.regionName = "";
      this.customerId = id;
      this.getCustomerRegionList({ customerId: id, page: 1, count: 2000 });

      if (this.formData.projectTeacherCourseId) {
        // 实训课id存在时
        this.queryCustomInfo();
      }
    },
    handleSelectRegion(item) {
      this.region.regionName = item.orgName;
      this.formData.customerOrgId = item.id;
      this.visible = "";
    },
    getCustomerRegionList(params) {
      getCustomerRegionList(params).then((res) => {
        if (res.errcode === 0) {
          this.region.regionList = res.data;
        }
      });
    },
    /**
     * 添加机构
     */
    handleAddRegion(params) {
      const { customerId } = this;
      createCustomerRegion({ ...params, customerId }).then((res) => {
        if (res.errcode === 0) {
          this.$toast.success("新增用户机构成功");
          this.getCustomerRegionList({ customerId, page: 1, count: 2000 });
        }
      });
    },
    /**
     * 查询客户信息
     */
    queryCustomInfo() {
      const { customerTel, projectTeacherCourseId } = this.formData;
      if (telRegExp.test(customerTel)) {
        this.queryCustomList(customerTel, projectTeacherCourseId)
          .then((res) => {
            const [customInfo] = res.data;
            this.hasCustomInfo = true;
            this.isPurchased = customInfo.purchased === 2; // 1、未购买， 2、已购买
            if (customInfo.parentId) {
              // 有客户归属人
              this.hasParentName = true;
              this.formData.customerParentId = customInfo.parentId;
            }
          })
          .catch(() => {
            this.hasParentName = false;
            this.hasCustomInfo = false;
            this.isPurchased = false;
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.van-form {
  background-color: #fff;

  .form-item {
    position: relative;

    &::after {
      content: "";
      width: calc(~"100% - 16px");
      position: absolute;
      bottom: 0;
      left: 16px;
      border-top: 1px solid #ebedf0;
      transform: scaleY(0.5);
    }

    .van-field {
      &--error {

        /deep/ textarea,
        /deep/ input {
          &::placeholder {
            opacity: 0;
          }
        }
      }
    }

    h4 {
      position: relative;
      margin: 0;
      padding: 10px 16px;
      font-size: 12px;
      color: rgba(128, 128, 128, 0.8);
      font-weight: normal;

      .van-checkbox {
        float: right;
        font-size: 14px;
      }

      &::after {
        content: "";
        position: absolute;
        width: calc(~"100% - 16px");
        bottom: 0;
        left: 16px;
        border-top: 1px solid #ebedf0;
        transform: scaleY(0.5);
      }
    }
  }

  .form-footer {
    text-align: center;
    padding: 20px 0;

    .van-button {
      padding: 0 30px;
    }
  }

  .region {
    color: #333;

    &-title {
      text-align: center;
      padding: 10px 0;
      font-size: 14px;
    }

    &-content {
      text-align: center;
      max-height: calc(~"40vh - 80px");
      overflow-y: auto;

      .region-list {
        position: relative;
        max-height: calc(~"100% - 124px");
        overflow-y: auto;

        &::before {
          content: "";
          width: 100%;
          position: absolute;
          bottom: 0;
          left: 0;
          border-top: 1px solid #ebedf0;
          transform: scaleY(0.5);
        }

        li {
          padding: 10px 0;
          font-size: 12px;
          position: relative;

          &:not(:first-child) {
            &::after {
              content: "";
              position: absolute;
              width: 100%;
              top: 0;
              left: 0;
              border-top: 1px solid #ebedf0;
              transform: scaleY(0.5);
            }
          }
        }
      }
    }

    &-footer {
      padding: 5px 0;

      .add-region {
        padding: 5px 0 10px;
        text-align: center;
        font-size: 14px;
        color: #0000ffc4;
      }

      .van-button {
        width: 100%;
        border: none;
        padding-top: 10px;
      }
    }
  }
}
</style>